"use strict";
/**
 * Copyright 2019, Optimizely
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var eventProcessor_1 = require("../eventProcessor");
var buildEventV1_1 = require("./buildEventV1");
var LogTierV1EventProcessor = /** @class */ (function (_super) {
    __extends(LogTierV1EventProcessor, _super);
    function LogTierV1EventProcessor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LogTierV1EventProcessor.prototype.formatEvents = function (events) {
        return {
            url: 'https://logx.optimizely.com/v1/events',
            httpVerb: 'POST',
            params: buildEventV1_1.makeBatchedEventV1(events),
        };
    };
    return LogTierV1EventProcessor;
}(eventProcessor_1.AbstractEventProcessor));
exports.LogTierV1EventProcessor = LogTierV1EventProcessor;
